import { alertBeforeUnload } from '../routing/alertBeforeUnload';
export const removeUnloadPopup = store => {
  const unloadAlert = alertBeforeUnload(store.dispatch);
  unloadAlert.removeAlert();
};